<script lang="ts">
  import Text from '../../common/components/Text.svelte';

  export let keyFeatures = [];
  let selectedTab;

  // Get unique tabs dynamically from keyFeatures
  let tabs = [];
  if (keyFeatures?.length) {
    const uniqueGroups = new Set(keyFeatures?.map(f => f.vasTypeGroupCode));
    tabs = Array.from(uniqueGroups).map(code => {
      const groupName = keyFeatures?.find(f => f.vasTypeGroupCode === code).vasTypeGroupName;
      return { code, name: groupName };
    });
    selectedTab = tabs[0]?.code; // Default to the first tab
  }

  // Filter features by vasTypeGroupCode
  const filterFeatures = groupCode => {
    return keyFeatures?.filter(feature => feature.vasTypeGroupCode === groupCode);
  };
</script>

<div class="extra-care-tab-content">
  <div class="tabs">
    <!-- Render tab buttons -->
    {#each tabs as tab}
      <button class:selected={selectedTab === tab?.code} on:click={() => (selectedTab = tab?.code)}>
        {tab?.name}
      </button>
    {/each}
  </div>
  <div class="what-included-text"><Text key="extra.vas.explore.popup.whats.included.text" /></div>
  <div class="tab-content">
    <!-- Render features for the selected tab -->
    {#each filterFeatures(selectedTab) as feature}
      <div class="services-info-list">
        <h3 class="services-info-title">{feature?.title}</h3>
        <ul>
          {#each feature?.features as item}
            <li>{item}</li>
          {/each}
        </ul>
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .extra-care-tab-content {
    .tabs {
      display: flex;
      gap: 1rem;
      margin-bottom: 1rem;
      border-top: 1px solid $secondary-gray-02;
      padding-top: 20px;
    }

    .tabs button {
      padding: 10px 0;
      border: none;
      background-color: transparent;
      color: $neutral-dark-01;
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
      cursor: pointer;
      margin-right: 20px;
      @include desktop-min-width {
        font-size: 18px;
        list-style: 32px;
      }
    }

    .tabs button.selected {
      background-color: transparent;
      color: $jood-blue-medium-01;
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      border-bottom: 2px solid $jood-blue-medium-01;
      @include desktop-min-width {
        font-size: 18px;
        line-height: 32px;
      }
    }

    .what-included-text {
      font-size: 20px;
      line-height: 22px;
      font-weight: 700;
      margin: 20px 0;
      color: $neutral-dark-01;
      @include desktop-min-width {
        font-size: 24px;
        line-height: 28px;
      }
    }
    .services-info-list {
      border: 2px solid $secondary-gray-02;
      border-radius: 8px;
      margin-bottom: 20px;
      .services-info-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
        color: $neutral-dark-01;
        padding: 0 15px;
      }
      ul {
        list-style: none;
        margin: 0;
        li::before {
          content: '• ';
          padding-right: 4px;
        }
        li {
          padding: 16px 20px;
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          border-bottom: 1px solid $secondary-gray-02;
        }
        li:last-child {
          border-bottom: 0;
        }
      }
    }
  }
</style>
